<template>
    <div>
        <keep-alive>
            <router-view :key="key"></router-view>
        </keep-alive>
    </div>
</template>

<script>
    export default {
        computed:{
            key() {
                const id = this.$route.query.id ? this.$route.query.id : ''
                return this.$route.path + id;
            }
        }
    }
</script>
